<template>
    <div class="shopCard" :class="{ 'horizontal': horizontalFlg }">
        <like-button
            :id="shop.id"
            :liked="shop.user_liked_flag"
            :like-count="shop.liked"
            :content-type="1"
            :auth="auth">
        </like-button>
        <div class="img"><a :href="shop.url"><img :data-src="shop.full_image_path" class="lazyload"></a></div>
        <div class="text">
            <div class="location">
                <ol>
                    <li>
                        <a href="#" @click.stop="search('island', shop.areaInfo.island_id)">
                            {{ shop.areaInfo.island_name }}
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.stop="search('area', shop.areaInfo.area_id)">
                            {{ shop.areaInfo.area_name }}
                        </a>
                    </li>
                </ol>
            </div>
            <h3 class="name"><a :href="shop.url">{{ display_name }}</a></h3>
            <ul class="chips">
              <li class="chip">{{ shop.small_category_name }}</li>
                <!-- <div class="chip icon star">{{ shop.star_count ?? 0 }}</div> -->
                <like-count
                    :id="shop.id"
                    :like-count="shop.liked"
                    like-style="chip icon heart"
                    :content-type="1">
                </like-count>
            </ul>
            <div v-show="coupons.length > 0" class="coupons">
                <p>お得なクーポンが<span class="count">{{ coupons.length }}枚</span>あります</p>
                <a :href="links.coupon + '?id=' + shop.id">すべて表示</a>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    props: {
      horizontalFlg: {
        type: Boolean,
        required: false,
        default: false
      },
      shop: Object,
      coupons: Array,
      links: Object,
      display_name: String,
      auth: {
        type: Boolean,
        default: false
      }
    },
      data() {
          return {
              search_word: null
          }
      },
      mounted() {
          this.getParam()
      },
      methods: {
          getParam() {
              const queryString = window.location.search
              const urlParams = new URLSearchParams(queryString)
              this.search_word = urlParams.get('search_word')
          },
          search(key, id) {
              const url = new URL(this.links.search)
              if (this.search_word) {
                  url.searchParams.append('search_word', this.search_word)
              }
              if (key && id) {
                  url.searchParams.append(key, id)
              }
              window.location.href = url
          }
      }
  }
</script>
